import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import classNames from 'classnames';
import styles from './styles.scss';
import { InlineIcon } from '../inline-icon/inline-icon';
import ArrowDownIcon from '../../icons/compiled/components/ArrowDownIcon';
export class Select extends React.Component {
  render() {
    const {
      options,
      disabled,
      dataHook,
      className,
      ariaLabel,
      onChange,
      selected,
      isRTL
    } = this.props;
    const arrowDownStyles = classNames(styles.arrowDown, {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    return /*#__PURE__*/React.createElement("div", {
      className: `${styles.wrapper} ${className}`,
      "aria-label": ariaLabel
    }, /*#__PURE__*/React.createElement(InlineIcon, {
      className: arrowDownStyles,
      icon: /*#__PURE__*/React.createElement(ArrowDownIcon, null)
    }), /*#__PURE__*/React.createElement("select", {
      "data-hook": dataHook,
      className: styles.select,
      onChange: onChange,
      value: selected || '',
      disabled: disabled
    }, options.map(opt => /*#__PURE__*/React.createElement("option", {
      key: opt.value,
      value: opt.value
    }, opt.text))));
  }
}
_defineProperty(Select, "defaultProps", {
  options: [],
  onChange: () => {},
  disabled: false,
  isRTL: false
});
//# sourceMappingURL=select.js.map